module.exports = __webpack_public_path__ + "static/wasiu-554d91e35cdedd08419b30953c8acde9.jpg";